import React from 'react';
import './EnterpriseSoftware.css';

const industries = [
    {
        title: 'Healthcare',
        icon: '🏥',
        details: [
            'Hospital Management Systems (HMS)',
            'Electronic Medical Records (EMR/EHR)',
            'Telehealth Platforms',
            'HIPAA & HL7 Compliance',
        ],
    },
    {
        title: 'Finance & Banking',
        icon: '🏦',
        details: [
            'Core Banking Systems',
            'Fraud Detection & KYC/AML',
            'Investment Management Tools',
            'Secure Payment Gateways',
        ],
    },
    {
        title: 'Manufacturing',
        icon: '🏭',
        details: [
            'ERP Systems',
            'Inventory & Supply Chain Tools',
            'Production Analytics',
            'IoT Integration',
        ],
    },
    {
        title: 'Retail & eCommerce',
        icon: '🏬',
        details: [
            'Omnichannel Platforms',
            'POS Systems',
            'Customer Loyalty Solutions',
            'Warehouse Management',
        ],
    },
    {
        title: 'Education & eLearning',
        icon: '🎓',
        details: [
            'Learning Management Systems (LMS)',
            'Virtual Classrooms',
            'Student Information Portals',
            'Online Exam Tools',
        ],
    },
    {
        title: 'Construction & Real Estate',
        icon: '🛠️',
        details: [
            'Project Management Software',
            'Tender & Bid Tools',
            'Billing & Scheduling',
            'Blueprint Collaboration',
        ],
    },
];

const features = [
    'Modular & Scalable Architecture',
    'Role-Based Access & Security Controls',
    'Cloud-Native & On-Premise Deployment',
    'Real-Time Reporting & Dashboards',
    'API Integration with Third-Party Tools',
    'AI & Automation Capabilities',
    'Data Encryption & Regulatory Compliance',
    'Multi-Platform Accessibility (Web, Mobile, Desktop)'
];

const benefits = [
    'Operational Efficiency – Automate and reduce errors',
    'Business Intelligence – Data-driven decisions',
    'High Security – Enterprise-grade protection',
    'Cross-Platform Accessibility – Web, mobile & desktop',
    'Seamless Integration – With your current ecosystem',
    'Scalability – Grows with your business needs',
    'User-Friendly Interface – Easy adoption for teams',
    'Real-Time Analytics – Instant insights & performance tracking'
];


const EnterpriseSoftware = () => {
    return (
        <div className="enterprise-container">
            <h1 className="enterprise-title">Enterprise Software Development</h1>
            <p className="enterprise-subtitle">
                Scalable, secure, and smart solutions tailored to your business needs. Empower your enterprise with centralized
                control, automation, and real-time insights.
            </p>

            <section className="enterprise-section">
                <h2 className="section-heading">Industries We Serve</h2>
                <div className="industry-grid">
                    {industries.map(({ title, icon, details }) => (
                        <div className="industry-card gradient-border-card" key={title}>
                            <h3 className="industry-title">{icon} {title}</h3>
                            <ul className="industry-list ">
                                {details.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </section>

            <section className="enterprise-section">
                <h2 className="section-heading">Key Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card bottom-border-card1" key={idx}>
                            <span className="card-icon">✅</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="enterprise-section">
                <h2 className="section-heading">Benefits of Our Enterprise Solutions</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card bottom-border-card1" key={idx}>
                            <span className="card-icon">🚀</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>


            <section className="cta-box">
                <h3>Let’s Build the Future of Your Enterprise</h3>
                <p>Modernize your legacy systems or create a brand-new enterprise solution from scratch.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Get a Free Consultation</button>
                </a>
              
            </section>
        </div>
    );
};

export default EnterpriseSoftware;
